<form [formGroup]="geoObjectSettingForm" class="example-form settings-form">

    <mat-form-field>
        <mat-label>{{'FORM.settingForm.title' | translate}}</mat-label>
        <input formControlName="title" matInput type="text" required>
    </mat-form-field>

    <mat-form-field >
        <mat-label>{{'FORM.gOLineTypesForm.lineColorName' | translate}}</mat-label>
        <input matInput formControlName="colorName" value="{{typeColorNameData}}" readonly/>
        <ngx-colors
          class="suffix"
          matSuffix
          ngx-colors-trigger
          [hideTextInput]="false"
          [format]="'hex'"
          formControlName="colorName"
        ></ngx-colors>
        <mat-error *ngIf="geoObjectSettingForm.controls['colorName'].hasError('invalidColor')" > The color is invalid. </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="this.data.data">
        <mat-label>{{'FORM.geoObjSettingForm.iconName' | translate}}</mat-label>
        <mat-label id="chooseIconName">{{data.data.iconName}}</mat-label>
        <mat-label id="oldIconName" style="display:none;">{{oldIconName}}</mat-label>

        <input id="actualIconName" formControlName="iconName" matInput type="text" style="display:none;">

        <div *ngFor="let icon of defaultIconsDropdownPoi">
            <button *ngIf="icon.iconName==data.data.iconName" mat-button class="mat-button-wrapper mr-1 p-4"  [value]="data.data.iconName" (click)="openIconPicker(this.data.data)" >
                <img [src]="'assets/icons/'+icon.iconAssetName+'.svg'" [alt]="icon.iconAssetName" width="50" height="50" >
            </button>
        </div>

        <button *ngIf="data.data.iconName=='no_icon'" mat-button class="mat-button-wrapper mr-1 p-4"  [value]="undefined" (click)="openIconPicker(this.data.data)" >
            <img [src]="'assets/icons/undefined.svg'" [alt]="iconAssetName" width="50" height="50" >
        </button>
        
        <button *ngIf="data.data.iconName==''" mat-button class="mat-button-wrapper mr-1 p-4"  [value]="undefined" (click)="openIconPicker(this.data.data)" >
            <img [src]="'assets/icons/undefined.svg'" [alt]="iconAssetName" width="50" height="50" >
        </button>

        <button *ngIf="data.data.iconName==null" mat-button class="mat-button-wrapper mr-1 p-4"  [value]="undefined" (click)="openIconPicker(this.data.data)" >
            <img [src]="'assets/icons/undefined.svg'" [alt]="iconAssetName" width="50" height="50" >
        </button>
    </mat-form-field>



    <mat-form-field *ngIf="!this.data.data">
        <mat-label>{{'FORM.geoObjSettingForm.iconName' | translate}}</mat-label>
        <mat-label id="chooseIconName">{{geoObjectSettingForm.value.iconName}}</mat-label>

        <input formControlName="iconName" matInput id="oldIconName" type="text" [value]="geoObjectSettingForm.value.iconName">
        <div >
            <!-- <div *ngFor="let icon of defaultIconsDropdown"> -->

            <!-- <button *ngIf="geoObjectSettingForm.value.iconName==icon.iconName; else undefinedIcon" mat-button class="mat-button-wrapper mr-1 p-4"  [value]="icon.iconName" (click)="openIconPicker(this.data.data)" >
                <img [src]="'assets/icons/'+icon.iconAssetName+'.svg'" [alt]="icon.iconAssetName" width="50" height="50" >
            </button>

            <button #undefinedIcon *ngIf="icon.iconName=='undefined' && geoObjectSettingForm.value.iconName==null" mat-button class="mat-button-wrapper mr-1 p-4"  [value]="icon.iconName" (click)="openIconPicker(this.data.data)" >
                <img [src]="'assets/icons/'+icon.iconAssetName+'.svg'" [alt]="icon.iconAssetName" width="50" height="50" >
            </button>     -->
            
            <button  mat-button class="mat-button-wrapper mr-1 p-4"  [value]="undefined" (click)="openIconPicker(undefined)" >
                <img *ngIf="geoObjectSettingForm.value.iconName==null; else dif;" [src]="'assets/icons/'+ undefined+'.svg'" [alt]="undefined" width="50" height="50" >
                <div #dif *ngFor="let icon of defaultIconsDropdown">
                    <!-- <p>{{icon.iconName}}</p> -->
                    <img *ngIf="icon.iconName==geoObjectSettingForm.value.iconName" [src]="'assets/icons/'+icon.iconAssetName+'.svg'" [alt]="undefined" width="50" height="50" >
                </div>
                    
            </button>
        </div>
    </mat-form-field>

    
    <mat-slide-toggle class="example-margin slide-toggle-text" formControlName="heading">
          {{'FORM.geoObjSettingForm.heading' | translate}}
    </mat-slide-toggle>

    <mat-slide-toggle class="example-margin slide-toggle-text" formControlName="shotRanges">
          {{'FORM.geoObjSettingForm.shotRanges' | translate}}
    </mat-slide-toggle>
    
    <mat-slide-toggle class="example-margin slide-toggle-text" formControlName="additionalObjects">
          {{'FORM.geoObjSettingForm.additionalObjects' | translate}}
    </mat-slide-toggle>

    <mat-slide-toggle class="example-margin slide-toggle-text" formControlName="testInterval">
          {{'FORM.geoObjSettingForm.testInterval' | translate}}
    </mat-slide-toggle>

    <mat-slide-toggle class="example-margin slide-toggle-text" formControlName="notificationChannel">
        {{'FORM.geoObjSettingForm.notificationChannel' | translate}}
  </mat-slide-toggle>

    <mat-slide-toggle class="example-margin slide-toggle-text" formControlName="usageInformation">
          {{'FORM.geoObjSettingForm.usageInformation' | translate}}
    </mat-slide-toggle>

    <div>
        <button [disabled]="geoObjectSettingForm.invalid || updateRight" class="my-4 first-stt-btn w-100" mat-raised-button type="submit" (click)="onSubmit()">
            {{ 'FORM.BTN_SAVE' | translate }}
        </button>

        <button [disabled]="isCreate || deleteRight" class="w-100 second-stt-btn mb-2" style="float:inline-end;" mat-button (click)="onDelete()">
            {{ 'FORM.BTN_DELETE' | translate }}
        </button>
    </div>



</form>
